import React from "react";
import style from "./PrimeraParte.module.css";

const PrimeraParte = ({ t }) => {
  return (
    <div className={style.container}>
      <h2 className={style.titulo}>
        {t("Products.SmartIOT.FirstPart.title")}
        <br />
        {t("Products.SmartIOT.FirstPart.title2")}
      </h2>

      <div className={style.divContainer}>
        {/* IZQUIERDA */}
        <div className={style.divIzq}>
          <p className={style.text}>{t("Products.SmartIOT.FirstPart.text")}</p>
          <p className={style.text}>{t("Products.SmartIOT.FirstPart.text2")}</p>

          <p className={style.text}>
            {t("Products.SmartIOT.FirstPart.text3")} {t("Products.SmartIOT.FirstPart.text4")}
          </p>

          <p className={style.text}>
            {t("Products.SmartIOT.FirstPart.text5")}
          </p>

          <p className={style.text}>
            {t("Products.SmartIOT.FirstPart.text6")}
          </p>
        </div>

        {/* DERECHA */}
        <div className={style.divDer}>
          <p className={style.title}>
            {t("Products.SmartIOT.SecondPart.title")}
          </p>
          <div className={style.separador}></div>

          <ul className={style.ul}>
            <li className={style.li}>{t("Products.SmartIOT.FirstPart.li2")}</li>
            <li className={style.li}>{t("Products.SmartIOT.FirstPart.li3")}</li>
            <li className={style.li}>{t("Products.SmartIOT.FirstPart.li4")}</li>
            <li className={style.li}>{t("Products.SmartIOT.FirstPart.li5")}</li>
          </ul>

          <p className={style.text}>
            {t("Products.SmartIOT.FirstPart.li12")} {t("Products.SmartIOT.FirstPart.text9")}
          </p>

          <p className={style.text}>
            {t("Products.SmartIOT.FirstPart.li13")} {t("Products.SmartIOT.FirstPart.text10")}
          </p>

          <p className={style.text}>{t("Products.SmartIOT.FirstPart.li14")}</p>
        </div>
      </div>
    </div>
  );
};

export default PrimeraParte;
